export default "__VITE_ASSET__rXr6zCym__"